import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { WarrenSession } from '@/modules/common/services/session';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  HelperViewStatus,
  DataTable,
  Heading,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';

import {
  getProfitDetail,
  ProfitDetailResponse,
  StockEvent
} from '@/modules/wealth/services/portfolio';
import { columns } from './columns';
import { Money } from '@/modules/common/components/MoneyV2';
import { MainError } from '@/modules/trade/components/MainError';
import { MainLoading } from '@/modules/trade/components/MainLoading';
import { StockProfitModal } from './components/StockProfitModal';
import { StorageKeys } from '@/modules/common/services/local-storage';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPortfolioProfit',
  setup(__props) {

const profitData = ref<ProfitDetailResponse | null>(null);
const isLoading = ref(false);
const hasError = ref(false);
const isModalOpen = ref(false);
const rowTicker = ref('');

const route = useRoute();
const router = useRouter();

const toggleModalOpen = () => {
  isModalOpen.value = !isModalOpen.value;
};

const portfolioId = computed(() => {
  const { portfolioId } = route.params;
  return portfolioId;
});

const query = computed(() => {
  const { year, month } = route.params;
  return { year, month };
});

const amount = computed(() => {
  return WarrenSession.get(StorageKeys.ProfitMonthlyAmount) || '-';
});

const handleGoBackClick = () => {
  WarrenSession.set('warren.indexPortfolio.filterOption', 'income');
  router.replace({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
};

const tableStatus = computed(() => {
  if (hasError.value) return 'error';
  if (isLoading.value) return 'loading';

  return 'default';
});

const month = computed(() => {
  const { month } = query.value;

  return month;
});

const year = computed(() => {
  const { year } = query.value;

  return year;
});

const getProfitData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;

    profitData.value = await getProfitDetail(
      portfolioId.value,
      year.value,
      month.value
    );
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const onRowClick = (row: StockEvent) => {
  rowTicker.value = row.name;
  isModalOpen.value = true;
};

onMounted(getProfitData);

return { __sfc: true,profitData, isLoading, hasError, isModalOpen, rowTicker, route, router, toggleModalOpen, portfolioId, query, amount, handleGoBackClick, tableStatus, month, year, getProfitData, onRowClick, NavBar, ContextColorProvider, HelperViewStatus, DataTable, Heading, HeadingDisplay, BackButton, ShowMoneyToggleButton, columns, Money, MainError, MainLoading, StockProfitModal }
}

})